import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {getAvslutaAffarByUserid,setofUpdatedashboard,decrypt,encrypt } from 'actions'
import { isEmpty,isUndefined } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'

function mapStateToProps({auth,DashBoard,accountsData}) {
  const { authUser} = auth;
  const { Flags,updatedashboard,DashBoardValueOf} = accountsData
    const { AvslutaAffar,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,AvslutaAffar,DashboardAnpassadFilterOption,Flags,updatedashboard,DashBoardValueOf
    };
}

function mapDispatchToProps(dispatch) {
  return {
      getAvslutaAffarByUserid: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getAvslutaAffarByUserid(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
      setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
     
      dispatch
  }
}
const useStyles = theme => ({
  root: {
      '&::-webkit-scrollbar': {
          width: '5px'
        },
         
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
         
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12484B',
          outline: '1px solid transparent'
        }
   },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#0E898F40',
      // backgroundColor: '#09585C80',
    },
  },
}))(TableRow);

class ClosedDeals extends Component {
  state={
    AvslutaAffar:[],
    DashboardAnpassadFilterOption:[],
    done: true
}
intervalID = null
componentDidMount=()=>{
  const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      axios.get(`kontos/DashBoard/getAFLBU`,
      { params:encrypt(JSON.stringify({
          Afid:Afid,
          FilterOption:[],
          intervaltype:this.props.intervaltype,
          userid:userid,
					DashView: 'individual'
        }))
      })
      .then(res => {
         if(res.data.success){
                        let endata = decrypt(res.data.encryptedData,res.data.iv)
                        let ndate = JSON.parse(endata)
                        this.setState({ 
                          AvslutaAffar:ndate.results.AvslutaAffar
                       });
                        this.initiateInterval()
                    }
       
     //   this.setState({done: true})   
    })
  }
  initiateInterval() {
      clearInterval(this.intervalID);
      this.intervalID= null
  this.intervalID = setInterval(
    () => {
      if(this.state.done === true){            
       // this.setState({done: false}) 
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      axios.get(`kontos/DashBoard/getAFLBU`,
      { params:encrypt(JSON.stringify({
          Afid:Afid,
          FilterOption:[],
          intervaltype:this.props.intervaltype,
          userid:userid,
					DashView: 'individual'
        }))
      })
      .then(res => {
        if(res.data.success){
          let endata = decrypt(res.data.encryptedData,res.data.iv)
          let ndate = JSON.parse(endata)
          this.setState({ 
            AvslutaAffar:ndate.results.AvslutaAffar
         });
          this.initiateInterval()
      }
    })
  }
    },
    180000
);
   
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  if(parseInt(this.props.updatedashboard) === 1){
    axios.get(`kontos/DashBoard/getAFLBU`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[],
        intervaltype:this.props.intervaltype,
        userid:userid,
				DashView: 'individual'
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          AvslutaAffar:ndate.results.AvslutaAffar
       });
        this.initiateInterval()
    }
  })
    this.props.setofUpdatedashboard()
  }
 
}
getDashBoardValueOf = ()=>{
  try{
  let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 1)
  if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
      return 2
  }else{
      return 1
  }
}
catch(error){return 1}
}
formatNumber=(number)=>{
  const _ValueOF = this.getDashBoardValueOf()
  return NumberFormat(number, _ValueOF === 2?'total':'standard', _ValueOF === 2?'default':'auto', 0)
  return NumberFormat(number, 'standard', 'auto', 0)
      return `${(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${this.props.Flags.ValueInNotyfile<=1?this.props.Flags.Enhet:this.props.Flags.Valuta}`
}
  render() {
    const { classes } = this.props;
    return (<>{
      this.state.done === false?
      <div style={{display: "flex",flexFlow: "column",width: "95%"}}>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      </div>
      :
      <div className={classes.root}
      style={{width:'95%',overflowY: "scroll", height: '100%'}}>
      {/* style={{width:'95%',overflowY: "auto",height: "400px"}}> */}
      <Table>
        <TableBody>
          {
            !isEmpty(this.state.AvslutaAffar)?
          this.state.AvslutaAffar.map(n => {
            return (
              <StyledTableRow key={n.index}>
                <TableCell align="left" 
                style={{ fontWeight: '400', paddingTop: '5px', paddingBottom: '5px', color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: '1px solid transparent', fontSize: isEmpty(this.props.fs) ? '14px' : this.props.fs }}>
                  {n.AF_kundnamn}
                  </TableCell>
                <TableCell align="left" style={{ fontWeight: '400', paddingTop: '5px', paddingBottom: '5px',color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: '1px solid transparent', fontSize: isEmpty(this.props.fs) ? '14px' : this.props.fs }}>{n.Regdate}</TableCell>
                <TableCell align="right" style={{ paddingTop: '5px', paddingBottom: '5px', color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: '1px solid transparent', fontSize: isEmpty(this.props.fs) ? '16px' : this.props.fs }}>
                  <b>{this.formatNumber(n.Value)}</b>
                </TableCell>
              </StyledTableRow>
            );
          }):""}
        </TableBody>
      </Table>
    </div>}</>
    );
  }
}

export default connect(
  mapStateToProps,mapDispatchToProps
)(withStyles(useStyles)(ClosedDeals));
